
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SortableOption } from "@/types/fieldsOptions";
import { OptionCheckbox } from './OptionCheckbox';

interface ThemeSelectionSectionProps {
  form: UseFormReturn<any>;
  themeOptions: SortableOption[];
}

export const ThemeSelectionSection = ({
  form,
  themeOptions
}: ThemeSelectionSectionProps) => {
  return <div className="grid grid-cols-2 gap-6 mt-3">
      <FormField control={form.control} name="campExperiences.0.themeMainKey" render={({
      field
    }) => <FormItem className="text-left">
            <FormLabel>Main theme</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select the main theme" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {themeOptions.map(option => <SelectItem key={option.id} value={option.id}>
                    {option.label}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </FormItem>} />

      <FormField 
        control={form.control} 
        name="campExperiences.0.themeOtherKeys" 
        render={() => (
          <FormItem className="text-left">
            <FormLabel>Other themes</FormLabel>
            <div className="space-y-1">
              {themeOptions.map(option => (
                <OptionCheckbox 
                  key={option.id} 
                  option={option} 
                  form={form} 
                  name="campExperiences.0.themeOtherKeys" 
                />
              ))}
            </div>
          </FormItem>
        )} 
      />
    </div>;
};
